import styled from "styled-components";

export const StyledPayoutBalanceSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
`;
export const StyledReadyToWithdrawAndPendingPayoutWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 2.4rem;
  flex-wrap: wrap;

  /* @media (max-width: 375px) {
    width: 3rem !important;
    height: 3rem !important;
  } */
`;
